module.exports = __webpack_public_path__ + "img/ai.ae10c305.jpg";